import { render, staticRenderFns } from "./AppProfile.vue?vue&type=template&id=e0e955d2&scoped=true&"
import script from "./AppProfile.vue?vue&type=script&lang=js&"
export * from "./AppProfile.vue?vue&type=script&lang=js&"
import style0 from "./AppProfile.vue?vue&type=style&index=0&id=e0e955d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e955d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex,VImg,VLayout})
